import { createContext } from "react";

export const JobListContext = createContext<any>(null);
